<div>
  <p class="spacing--none ag-cell-fund-name" *ngIf="isSoftLaunch">
    <ng-container *ngTemplateOutlet="fundNameContent"></ng-container>
  </p>
  <p class="spacing--none ag-cell-fund-name" *ngIf="!isSoftLaunch">
    <eds-link-item
      class="ag-cell-frk--link"
      [href]="fundLink"
      eventId="linkOrButtonClick"
    >
      <ng-container *ngTemplateOutlet="fundNameContent"></ng-container>
    </eds-link-item>
  </p>
  <ng-container *ngIf="showSalesCharges">
    <p class="spacing--none small">
      <span>
        {{ "products.sales-charges" | translate }} :
        {{ "products.max-initial-charge" | translate }}
        - {{ maxIntialSalesCharge }} | {{ "products.cdsc" | translate }} -
        {{ cdsc }}
      </span>
    </p>
  </ng-container>
</div>

<ng-template #fundNameContent>
  <div>{{ fundDetail?.fundName }}</div>
  <div class="small text-grey1">{{ fundDetail?.row1 }}</div>
  <div class="small text-grey1">{{ fundDetail?.row2 }}</div>
</ng-template>
